export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 10.49,
        "transcript": "Mat'ukun wangkuta yuilqurmiutarmun kuigmiutarmun-llu neqnek-llu unangengnaqtullruukut.",
        "translation": "Through this, we used to try to get land and river animals, and fish."
    },
    "2": {
        "startTime": 10.92,
        "endTime": 17.79,
        "transcript": "Unangaqluta. Quyrtengnaqaqamta, pingnaqaqamta unangaqluta.",
        "translation": "We would obtain [animals]. When we tried to gather and strived, we would get things."
    },
    "3": {
        "startTime": 17.79,
        "endTime": 23.67,
        "transcript": "Pingnaqenrilnguq-llu caunani, arrsaunani, arrsauluni neqkaunani-llu.",
        "translation": "And the one who didn't try had nothing, was poor, and had no food."
    },
    "4": {
        "startTime": 23.675,
        "endTime": 31.505,
        "transcript": "Tua-i-gguq tauna camek quyurcingnaqenrilnguq tua-i tuaten pilaraat.",
        "translation": "That's how they talk about that person that doesn't try to gather."
    },
    "5": {
        "startTime": 31.505,
        "endTime": 35.775,
        "transcript": "Tau͡gaam-gguq pingnaqellria unangaqluni.",
        "translation": "But they said that the one who strives gets things."
    },
    "6": {
        "startTime": 35.787,
        "endTime": 48.487,
        "transcript": "Nallemteńi tamaani aipainret, cali-llu calriit, tua-i-w' arrsaulrianek ap'laqput",
        "translation": "In our time back then, the widoes, and, you know, the ones we call poor"
    },
    "7": {
        "startTime": 48.494,
        "endTime": 50.931,
        "transcript": "Cali-llu elliraat",
        "translation": "And orphans"
    },
    "8": {
        "startTime": 50.944,
        "endTime": 58.306,
        "transcript": "Pitangqellruut tamatum nalliini akimek aulukutailnguut",
        "translation": "There were those kinds of people at that time who had no money to take care of them"
    },
    "9": {
        "startTime": 59.244,
        "endTime": 64.494,
        "transcript": "Welfare-anek pitaitellruami tamatum nalliini.",
        "translation": "Because there was no welfare at that time."
    },
    "10": {
        "startTime": 64.501,
        "endTime": 74.876,
        "transcript": "Tau͡gaam yuut ellmeggnek ukut piyugngalriit, yuilqumek unangyugngalriit, pingnaqelriit",
        "translation": "But the people that were able to do things themselves, who could catch things from the wilderness, the ones who subsisted"
    },
    "11": {
        "startTime": 74.895,
        "endTime": 78.945,
        "transcript": "Unangqayuluteng neqkanek quyurcilartut.",
        "translation": "They are good at hunting and gathering, and gather food."
    },
    "12": {
        "startTime": 78.952,
        "endTime": 91.464,
        "transcript": "Tua-i-gguq tamaa-i tamakunun aulukestekaulria Agayutem cikiumaluku tuaten unanglliqevkarluku, tamakunun cikiutekangevkarluku.",
        "translation": "They said that those people were given the gift of catching things by the caretaker, God, who had them receive those gifts."
    },
    "13": {
        "startTime": 91.477,
        "endTime": 98.077,
        "transcript": "Tua-i nutaan piuralaraakut waten imkut angayuqamta:",
        "translation": "Our parents would always say this to us:"
    },
    "14": {
        "startTime": 98.096,
        "endTime": 104.746,
        "transcript": "\"Kitaki pikuvet, elpenek piyaureskuvet",
        "translation": "\"When you are [on your own], when you start taking care of yourself"
    },
    "15": {
        "startTime": 105.753,
        "endTime": 114.953,
        "transcript": "\"Yugnek tuaten elpet pikangqerquvet, ikayuutekangluten unangekuvet",
        "translation": "\"For the people, if you have some of your own, if you get things that are of help"
    },
    "16": {
        "startTime": 115.947,
        "endTime": 123.672,
        "transcript": "\"Neqkailnguq neqkaanek pingnaqluku pikangqerrutacirpetun",
        "translation": "\"Give as much food as you can for one who has no food"
    },
    "17": {
        "startTime": 124.041,
        "endTime": 130.878,
        "transcript": "\"Aipainret, arrsaulriit, elliraat arcaqerluki.",
        "translation": "\"Especially for widows, the poor, and orphans."
    },
    "18": {
        "startTime": 131.091,
        "endTime": 142.228,
        "transcript": "\"Neqkarrlainaq-llu kiingan pivkenaku, aturarkaanek-llu pikangqerquvet, cipnengqerquvet",
        "translation": "\"And not only with food, if you have clothes for him, and spares"
    },
    "19": {
        "startTime": 142.241,
        "endTime": 147.791,
        "transcript": "\"Atu'urkaanek ikayurluku pikangqerquvet.",
        "translation": "\"Help him with the clothes he [needs] if you have any."
    },
    "20": {
        "startTime": 147.81,
        "endTime": 157.76,
        "transcript": "\"Tua-i tamaa-i elpet taumun ikayuutekarpenek tuaten pingqerquvet pinarqaaten.\"",
        "translation": "\"If you can help that person if you have any to spare, you must do that.\""
    },
    "21": {
        "startTime": 157.767,
        "endTime": 167.917,
        "transcript": "Tua-i cali waten taukut cali pilaqaitkut",
        "translation": "Those people would also tell us"
    },
    "22": {
        "startTime": 167.936,
        "endTime": 170.936,
        "transcript": "Tamanarrlainaq pivkenaku",
        "translation": "Not only that"
    },
    "23": {
        "startTime": 170.943,
        "endTime": 183.03,
        "transcript": "Iliini unuakumi wiinga imum aanama tamaani ayagyuarlua pilaqiinga maktaqama",
        "translation": "Some mornings when I was young back then, my mother would tell me when I got up"
    },
    "24": {
        "startTime": 184.105,
        "endTime": 192.143,
        "transcript": "\"Kitaki qakemkut yuut paqeski.",
        "translation": "\"Now, go check on the people out there."
    },
    "25": {
        "startTime": 193.656,
        "endTime": 200.893,
        "transcript": "\"Mericiiqut, muraiciiqut, camek piiciiqut.",
        "translation": "\"[Some] will have no water, no wood, they will lack something."
    },
    "26": {
        "startTime": 200.906,
        "endTime": 206.893,
        "transcript": "\"Ullagluki paqeski tamakut imkut arnat-llu pistailnguut-llu.\"",
        "translation": "\"Go to them and check on them, including the women and those who have no providers.\""
    },
    "27": {
        "startTime": 206.943,
        "endTime": 220.468,
        "transcript": "Tua-i tuaten pisquciatun nallunrit'laamki tamakut arnat pistailnguut-llu tuaten pinarquciat",
        "translation": "So, as she said, since I knew that those women and those without providers needed to be [helped] like that"
    },
    "28": {
        "startTime": 220.487,
        "endTime": 224.474,
        "transcript": "Ellmeggnek muragciigalnguut-llu mertarciigalnguut",
        "translation": "The ones who couldn't get wood and water by themselves"
    },
    "29": {
        "startTime": 224.587,
        "endTime": 232.674,
        "transcript": "Ullagluki nutaan wiinga tememkun tua-i tamaa-i ikayuutekat cali neqngunrilengraan.",
        "translation": "I went to them and helped them with my physical power even though it wasn't food."
    },
    "30": {
        "startTime": 232.687,
        "endTime": 238.999,
        "transcript": "Tamaa-i muraitelleq-am, muriit-llu neqkaunitullruiceteng tamaani.",
        "translation": "Being without wood, because they also said that wood was for food preparation back then."
    },
    "31": {
        "startTime": 239.012,
        "endTime": 242.162,
        "transcript": "Murak-gguq neqkatun ayuquq.",
        "translation": "They said that wood is like food."
    },
    "32": {
        "startTime": 242.306,
        "endTime": 248.306,
        "transcript": "Tua-i-gguq neqkamek kenirciigaciiquq murailkuni.",
        "translation": "THey said that one cannot cook food without wood."
    },
    "33": {
        "startTime": 248.313,
        "endTime": 255.55,
        "transcript": "Tua-i-am tamaa-i share-allerkaqa wii tua-i waken anglicartemnek tuaten pisqellua",
        "translation": "That is what I wanted to share from those who raised me, telling me to do that"
    },
    "34": {
        "startTime": 255.55,
        "endTime": 262.663,
        "transcript": "\"Kitaki qakemkut paqeski, camek nuqlitellratnek ikayurniaten.",
        "translation": "\"Now, go check on the people out there, and help them with what they lack."
    },
    "35": {
        "startTime": 263.7,
        "endTime": 274.375,
        "transcript": "\"Cali tua-i neqkangqerquvet nallunrilkengangqerquvet kitaki neqkamek cali pingnaqkiu yuk tauna.",
        "translation": "\"Also, if you have any food, and you know someone [who is without], try to give that person food."
    },
    "36": {
        "startTime": 274.381,
        "endTime": 282.269,
        "transcript": "\"Tua-i elliin atam quyatii taum yuum elpenun angqapigtuq.'",
        "translation": "\"You see, that person's gratitude towards you is very great.\""
    },
    "37": {
        "startTime": 282.282,
        "endTime": 291.244,
        "transcript": "Atam-gguq quyatii aulukestemta Ellam Yuan cimirniaraa tauna amllenranek.",
        "translation": "Watch, they said, our caretaker, the Spirit of the Universe will exchange his gratitude in greater amount."
    },
    "38": {
        "startTime": 291.257,
        "endTime": 297.407,
        "transcript": "Una tua-i sharing-aaq waten pitaqerluku.",
        "translation": "This is all for this sharing."
    },
    "39": {
        "startTime": 297.414,
        "endTime": 307.051,
        "transcript": "Atunem ikayuutellerkaq, cikirtuutellerkaq nuqlitellra tua-i pitaciatun tangerrluku.",
        "translation": "To help and give each other what they lack, depending on how much [they need]."
    },
    "40": {
        "startTime": 308.564,
        "endTime": 312.551,
        "transcript": "Waten una pitaqerluku una piaqa waten.",
        "translation": "This is all I have to say about this."
    },
    "41": {
        "startTime": 313.626,
        "endTime": 317.364,
        "transcript": "Okay. I just wanted to...",
        "translation": "Okay. I just wanted to..."
    },
    "42": {
        "startTime": 320.739,
        "endTime": 326.539,
        "transcript": "Tua-i ikayuqengyaraq man'a avaken ayagluni piulria.",
        "translation": "Helping each other is an ancient practice."
    },
    "43": {
        "startTime": 326.558,
        "endTime": 337.558,
        "transcript": "Avani-llu au͡gkut ikayuq'ngelriit akimek tegucuyuitellruut. Akingyuunateng ikayuq'ngellruut au͡gkut ciuqliit.",
        "translation": "And back then, those who helped others wouldn't want to take payment. The people long ago would help others without payment."
    },
    "44": {
        "startTime": 338.659,
        "endTime": 346.447,
        "transcript": "Ikayuq'ngetullruut akiliryarauvkenani.",
        "translation": "They would help others without needing payment."
    },
    "45": {
        "startTime": 346.46,
        "endTime": 353.885,
        "transcript": "Ilakelriit-llu tungelquqelriit quyurmeng eneni uitatullruut, enemi ataucimi.",
        "translation": "The families, relatives, would stay together in houses, in one house."
    },
    "46": {
        "startTime": 353.891,
        "endTime": 357.266,
        "transcript": "Tamaa-i tamatum nalliini",
        "translation": "At that time"
    },
    "47": {
        "startTime": 358.022,
        "endTime": 368.022,
        "transcript": "Ilakelriit tungelquqelriit enemi ataucimi, enerpall'e'rmi, marayami enemi muragnek aklulegmi",
        "translation": "The families, relatives in one house, a large house, in a sod house that had wooden furniture"
    },
    "48": {
        "startTime": 368.029,
        "endTime": 370.541,
        "transcript": "Tua-i uitaaqluteng.",
        "translation": "They lived [there]."
    },
    "49": {
        "startTime": 370.554,
        "endTime": 381.392,
        "transcript": "Ikegkuk pikani yuungnaqelriik, ukuk-ll' irnialgek, tua-i tuaten cetamauluteng enem iluani uitatullrulliniut.",
        "translation": "Across there, the two who made their own living up there, and here the two with children, four of them would live in a house like that."
    },
    "50": {
        "startTime": 381.542,
        "endTime": 389.455,
        "transcript": "Wiinga-llu ellma angucuayaallruaqa tamana tuaten uitalallrat enepigni marayani.",
        "translation": "I was also born on the cusp of that time, when they lived in traditional sod houses."
    },
    "51": {
        "startTime": 389.467,
        "endTime": 396.917,
        "transcript": "Tungayakelriit tungelququtellruut. Kenkutellruut au͡gkut yuut.",
        "translation": "Relatives were tight knit. People back then loved each other."
    },
    "52": {
        "startTime": 397.774,
        "endTime": 404.161,
        "transcript": "Waniwa-llu tua-i wiinga ciulianka Qinarmiunguyaaqut.",
        "translation": "And now, my ancestors are from Qinaq."
    },
    "53": {
        "startTime": 404.174,
        "endTime": 410.111,
        "transcript": "Imum unuaq au͡g'um nangerrluni qalartellriim Qinarmiun nunalgutkaanga",
        "translation": "I am from the same village as the one from Qinaq who stood up and spoke this morning"
    },
    "54": {
        "startTime": 410.124,
        "endTime": 417.136,
        "transcript": "Imum wani au͡g'um tan'gaurluum ciuqlikacaarmek ikirutestellemta.",
        "translation": "That boy who was the very first one to open our meeting."
    },
    "55": {
        "startTime": 417.149,
        "endTime": 421.349,
        "transcript": "Ciulianka angayuqaagka Qinarmiungullruuk",
        "translation": "My ancestors, my parents were from Qinaq."
    },
    "56": {
        "startTime": 421.356,
        "endTime": 428.893,
        "transcript": "Tamaa-i tamaani ellangartellemni ataucimek Kass'angqellruut taukut nunat.",
        "translation": "Back in my earliest memories, that village had one resident Caucasian."
    },
    "57": {
        "startTime": 430.443,
        "endTime": 441.006,
        "transcript": "Ellangartellruunga nunanek taukunek kuigem au͡g'um akiqliqluteng nunauluteng.",
        "translation": "That village is part of my first memories, where the houses were across the river from each other."
    },
    "58": {
        "startTime": 441.018,
        "endTime": 446.143,
        "transcript": "Taumek Kass'amek ataucimek Kass'angqellrulliniut taukut nunat.",
        "translation": "That village had that man as their one resident Caucasian."
    },
    "59": {
        "startTime": 447.274,
        "endTime": 455.149,
        "transcript": "Tua-i arenqiatuq ikayuqengyaraq au͡gna maa-i mat'um nalliini tua-i-am atunrirtuq.",
        "translation": "It is unfortunate that helping others is no longer practiced these days."
    },
    "60": {
        "startTime": 455.843,
        "endTime": 464.73,
        "transcript": "Makut arrliurciigaliit piyugngang'e'rmeng ayagyuat makut wani ellmeggnek pisciigalnguut.",
        "translation": "Though these young people are able, they cannot help those who cannot provide for themselves to prepare."
    },
    "61": {
        "startTime": 464.743,
        "endTime": 469.23,
        "transcript": "Akiinateng-llu, akirraunateng piqerciigaliluteng.",
        "translation": "They can't do it without payment, any small payment, anymore."
    },
    "62": {
        "startTime": 469.243,
        "endTime": 474.143,
        "transcript": "Avani tamakut yuut kenka atullrulliniat.",
        "translation": "Apprently, those people back then practiced love."
    },
    "63": {
        "startTime": 477.85,
        "endTime": 488.775,
        "transcript": "Neqsurciigalnguut-llu yuurqerciigalnguut-llu Kass'artarmek caliyuilnguut",
        "translation": "And those who can't fish, and those who don't work and can't drink Western tea"
    },
    "64": {
        "startTime": 489.844,
        "endTime": 496.044,
        "transcript": "Uksurpak nerumavkalallruit cikiutet yugnek.",
        "translation": "All winter, they would have people eat the gifts they were given."
    },
    "65": {
        "startTime": 496.051,
        "endTime": 506.638,
        "transcript": "Wiinga-llu ellangellruunga, tua-i mikcuaraulua ataka catairutellrani ellangartellruunga.",
        "translation": "And in my earliest memories, my earliest memories of when I was very small and my father passed away."
    },
    "66": {
        "startTime": 507.328,
        "endTime": 518.514,
        "transcript": "Tamaa-i-llu tua-i kinguani tuaken tua-i ellangeqarraarrarvillemnek",
        "translation": "And after that, from the place where I had my first memories"
    },
    "67": {
        "startTime": 518.788,
        "endTime": 530.717,
        "transcript": "Wavet Elumarvigmun anaanama uingan itrautellruitkut.",
        "translation": "My maternal aunt's husband brought us upriver here to Elumarvik."
    },
    "68": {
        "startTime": 530.742,
        "endTime": 536.627,
        "transcript": "Tamaa-i cali uani Elumarvigmi cali uitallruunga ellangvimnun.",
        "translation": "I also stayed downriver at Elumarvik until I became aware."
    },
    "69": {
        "startTime": 536.634,
        "endTime": 541.476,
        "transcript": "Nutaan-llu tuaken ellaka nalluyagutenqigtevkenaku.",
        "translation": "And ever since then, I've had become fully aware."
    },
    "70": {
        "startTime": 542.793,
        "endTime": 549.778,
        "transcript": "Yuut aulukellruitkut, aanaka castaunani.",
        "translation": "People took care of us, with my mother having no providers."
    },
    "71": {
        "startTime": 550.542,
        "endTime": 561.314,
        "transcript": "Cikiutet quyanarqellruut caknerpak neqkat, aturarkat-llu",
        "translation": "The gifts were cause for great thanks, food, and clothes"
    },
    "72": {
        "startTime": 561.319,
        "endTime": 565.834,
        "transcript": "Aturarkat-wa tua-i tamaa-i qaim mat'um patukai.",
        "translation": "Clothing that covers the body here."
    },
    "73": {
        "startTime": 565.855,
        "endTime": 572.469,
        "transcript": "Yugnek cikiutet angqapiarallruut wangni umyuamni.",
        "translation": "People's gifts were extremely great in my mind."
    },
    "74": {
        "startTime": 572.475,
        "endTime": 575.918,
        "transcript": "Quyanaqiarluteng caknerpak.",
        "translation": "I was extremely thankful for them."
    },
    "75": {
        "startTime": 576.494,
        "endTime": 586.835,
        "transcript": "Atalegnek ilalegnek, ilalilrianek ayuqniatullruunga, anelgut'lilrianek.",
        "translation": "I would covet families with fathers, those with large familes, with many siblings."
    },
    "76": {
        "startTime": 588.503,
        "endTime": 599.231,
        "transcript": "Tamaa-i yuut ikayuq'ngellrata, aulukellrata, ikayuutellrata",
        "translation": "The people's helping others, taking care of others, helping each other"
    },
    "77": {
        "startTime": 599.252,
        "endTime": 609.752,
        "transcript": "Waten wiinga tua-i maa-i mat'um nalliini qanerkangqercetaatnga yuut tamakut ciuqliit ikayuq'ngellret.",
        "translation": "Those people back then who helped others gave me something to say today."
    },
    "78": {
        "startTime": 609.771,
        "endTime": 613.242,
        "transcript": "Quyanaqpiarluteng caknerpak.",
        "translation": "I am extremely thankful for them."
    },
    "79": {
        "startTime": 613.728,
        "endTime": 621.156,
        "transcript": "Maa-i tang mat'um nalliini iciwa qanlalriaci yuut ayuquciat cimirniluku.",
        "translation": "Now, you see, you know you say that people's behavior has changed these days."
    },
    "80": {
        "startTime": 621.165,
        "endTime": 624.908,
        "transcript": "Cimiutai nallunritaput.",
        "translation": "We know what has changed."
    },
    "81": {
        "startTime": 624.921,
        "endTime": 629.335,
        "transcript": "Tungelquqelriit, tungayakelriit tungayakutenrirtut.",
        "translation": "Relatives, close relatives do not act as relatives anymore."
    },
    "82": {
        "startTime": 629.355,
        "endTime": 638.37,
        "transcript": "Ilaita-llu tungayateng, aanameng-llu ilait nalluaqluki, atameng-llu tungayait-llu nalluaqluki mat'um nalliini.",
        "translation": "And they don't know some of their relatives, their mom's relatives, and their father's relatives these days"
    },
    "83": {
        "startTime": 638.378,
        "endTime": 644.621,
        "transcript": "Maa-i-w' tua-i cimian tamana yuut kenkutellrat.",
        "translation": "Because the way people [used to] love each other has changed now."
    },
    "84": {
        "startTime": 645.592,
        "endTime": 655.006,
        "transcript": "Tua-llu aptaqama tamaani kinguani, \"Qaillun taukut enem iluanelnguut yuulruat?\"",
        "translation": "And then when I asked after that time, \" How did those people in that house live?“"
    },
    "85": {
        "startTime": 655.018,
        "endTime": 657.804,
        "transcript": "Taum aanama qanrutaqlua waten:",
        "translation": "My mother would tell me this:"
    },
    "86": {
        "startTime": 657.827,
        "endTime": 673.541,
        "transcript": "\"Yuut-gguq taukut yuullruut una piutengqerpek'nani, una-llu neqautminek qanyuunani nangqatalrianek, nangelrianek-llu qanyuunani.",
        "translation": "\"In the live those people lived, one didn't have any possessions, and this one didnt say their food was running out, and no one said [food] ran out."
    },
    "87": {
        "startTime": 673.544,
        "endTime": 679.416,
        "transcript": "\"Ilakuyutqapiarluteng ilakuyutellriit ataucimek nerluteng.",
        "translation": "\"The extremely close-knit family ate from one store."
    },
    "88": {
        "startTime": 680.831,
        "endTime": 684.574,
        "transcript": "\"Kina-llu qunuyuunani.\"",
        "translation": "\"And no one refused to share.\""
    },
    "89": {
        "startTime": 685.344,
        "endTime": 691.858,
        "transcript": "Tua-i-gguq tamakut tungelququtellriit ilateng ikayuapiatullruit cakneq.",
        "translation": "She said that those relatives helped out their relatives as much as possible."
    },
    "90": {
        "startTime": 691.885,
        "endTime": 700.528,
        "transcript": "Camek-llu qunucuunaki, kiingan-llu pik'nge'rmegteggu tua-i taumun, taumun aturcetaqluku akiinaku.",
        "translation": "They wouldn't refuse them anything, and even if it was their only one, they would have them use it without payment."
    },
    "91": {
        "startTime": 700.793,
        "endTime": 715.693,
        "transcript": "Maa-i tang mat'um nalliini ca tamarmi carraquinrayagaq akiyuutngurtellria ikayuutekaq, cikiutekaq.",
        "translation": "These days, you see, every little thing needs payment that should be given as assistance, as gifts."
    },
    "92": {
        "startTime": 716.719,
        "endTime": 720.89,
        "transcript": "Cali alerquutengqerrluta wangkuta.",
        "translation": "We also had traditional instructions."
    },
    "93": {
        "startTime": 722.987,
        "endTime": 734.258,
        "transcript": "Arnaungramta, arnarraungramta, camek-llu kipulluta pisciigalengramta ikayuqengyugnganiluta yugnek.",
        "translation": "Even though we were women, just women, and though we couldn't buy anything, they said we could help people out."
    },
    "94": {
        "startTime": 734.278,
        "endTime": 741.707,
        "transcript": "Umyuartequa tuani waten mat'umek niitellemni: \"Wii-kiq ca aturluku ikayuqengniarcia?\"",
        "translation": "I thought this when I heard this: \"I wonder what I will use to help others out?“"
    },
    "95": {
        "startTime": 741.83,
        "endTime": 745.144,
        "transcript": "Taum waten aanama pianga:",
        "translation": "My mother said this to me:"
    },
    "96": {
        "startTime": 745.32,
        "endTime": 753.72,
        "transcript": "\"Camek qanruskuvgu nanikualria, assilriamek qanruskuvgu ikayurciqan.\"",
        "translation": "\"If you say something to someone who feels hopeless, you will help him if you tell him something good.\""
    },
    "97": {
        "startTime": 753.73,
        "endTime": 756.802,
        "transcript": "Tua-llu waten pianga cali:",
        "translation": "Then she also said this to me:"
    },
    "98": {
        "startTime": 756.825,
        "endTime": 771.239,
        "transcript": "\"Qainga allgulria allganlilria mingqestailnguq, natii imna allganruarii-llu nunguareskuvgu tauna ikayurarkaugan.\"",
        "translation": "\"The one who has torn clothes with no one to sew them, if you sew the torn parts closed, you will help him.\""
    },
    "99": {
        "startTime": 771.249,
        "endTime": 781.691,
        "transcript": "Tang maa-i ikayutekelput au͡gkunek avani tua-i yuullemteńi wangkuta akimek ikayuutekaunata.",
        "translation": "You see, this is how we helped others in our lives back then when we had no money to help others."
    },
    "100": {
        "startTime": 781.953,
        "endTime": 784.753,
        "transcript": "Ikayuutektullruaput tua-i",
        "translation": "That's how we helped others"
    },
    "101": {
        "startTime": 785.241,
        "endTime": 792.498,
        "transcript": "Atulallruamku-llu wii man'a nunguarcilalqa makunek.",
        "translation": "And because I used to do that, sewed close these [torn clothes]."
    },
    "102": {
        "startTime": 792.504,
        "endTime": 798.447,
        "transcript": "Atam cali elitengqertuq kia imum ayagniquniu man'a.",
        "translation": "You see, someone can learn to do it if they start this."
    },
    "103": {
        "startTime": 798.462,
        "endTime": 805.605,
        "transcript": "Maani-llu allgulriamek tangerquni, tua-i-ll' umyuaqerrluku, \"Waniwa-tuq una kitugglaku.\"",
        "translation": "Then when they see torn [clothes], they will think, \"Let me fix this.\""
    },
    "104": {
        "startTime": 805.623,
        "endTime": 810.866,
        "transcript": "Tuaten elitnarquq. Ca tamarmi elitengqertuq.",
        "translation": "One learns that way. You can learn anything."
    },
    "105": {
        "startTime": 810.877,
        "endTime": 815.548,
        "transcript": "Tamana tuaten atullemni elitellruaqa.",
        "translation": "When I did that, I learned how to do it."
    },
    "106": {
        "startTime": 815.566,
        "endTime": 822.552,
        "transcript": "Tua-i Kassaungraata-llu, makuungraata tangrraqamki piyugnaaqnaunka.",
        "translation": "Even if they're Caucasian, no matter who they are, when I see them, I want to [help] them."
    },
    "107": {
        "startTime": 822.566,
        "endTime": 827.295,
        "transcript": "Nungucugyaaqluku-llu tauna allganeq umyuarteqaqlua",
        "translation": "And I think, wanting to sew that tear closed"
    },
    "108": {
        "startTime": 827.309,
        "endTime": 831.666,
        "transcript": "Tua-i-wa ca tamarmi elitengqerrami.",
        "translation": "Because you can learn to do anything."
    },
    "109": {
        "startTime": 832.576,
        "endTime": 837.276,
        "transcript": "Ikayuqengyaraq yuum ikayuutekaa amllertuq.",
        "translation": "There are many ways you can help a person."
    },
    "110": {
        "startTime": 849.309,
        "endTime": 859.566,
        "transcript": "Amlleq ikayurtaagutlerkaq neqkatgun ava-i tua-i ilii taringekvut",
        "translation": "We understood a lot about a part of helping each other through food"
    },
    "111": {
        "startTime": 859.576,
        "endTime": 867.018,
        "transcript": "Avani ikayurtaagutetullruamta wangkuta nallemteńi cikirtaagulluta.",
        "translation": "Because we would help each other in our time back then, giving to each other."
    },
    "112": {
        "startTime": 867.039,
        "endTime": 877.396,
        "transcript": "Neqkamek-llu up'nerkami nuqliterpalaameng ilait unangyuilnguut, neqsuyuilnguut, pisciigalnguut",
        "translation": "And because people would have great scarcity of food in the winter, those who don't catch anything, don't fish, and are unable"
    },
    "113": {
        "startTime": 877.403,
        "endTime": 886.332,
        "transcript": "Tamaaggun tua-i kanautelaamteki maavet neq'ngellerkaanun.",
        "translation": "Because through that, we go down to the water until they have food."
    },
    "114": {
        "startTime": 886.761,
        "endTime": 897.975,
        "transcript": "Tau͡gaam una waniw' nugtarrvikluku piqataraput atunem ikayurtaagutlerkaq",
        "translation": "But now, we're going to move on to this subject, helping each other"
    },
    "115": {
        "startTime": 899.116,
        "endTime": 903.373,
        "transcript": "Atunem ikayurtaagutlerkaq.",
        "translation": "Helping each other."
    },
    "116": {
        "startTime": 903.828,
        "endTime": 911.914,
        "transcript": "Pillgutekluni camek wangkuta ikayurtaagulluta.",
        "translation": "Helping each other in accordance with something."
    },
    "117": {
        "startTime": 911.927,
        "endTime": 916.956,
        "transcript": "Wall' nunalegni cat ilaitni atutuarput tamana.",
        "translation": "Or in vilalges, we sometimes practice that."
    },
    "118": {
        "startTime": 918.338,
        "endTime": 925.938,
        "transcript": "Camek ilavut tua-i carpagmek iliini caliangqelartuq",
        "translation": "Sometimes, one of our own has a great job to do"
    },
    "119": {
        "startTime": 925.945,
        "endTime": 930.073,
        "transcript": "Wall'u enelingnaqluni-llu",
        "translation": "Or trying to build a house"
    },
    "120": {
        "startTime": 930.556,
        "endTime": 943.499,
        "transcript": "Wall'u muragnek tamaani enengqetuameng, tuskanek piyuitellruameng tamatum nalliini, makunek plywood-at-llu cataitellruameng tamatum nalliini.",
        "translation": "Or because they had wooden houses, because they didn't have plywood at that time, and because there was no plywood at that time."
    },
    "121": {
        "startTime": 943.5,
        "endTime": 952.272,
        "transcript": "Tau͡gaam muragnek enekarrluteng yuut maani Kusquqvagmi pitullruameng",
        "translation": "But because people here on the Kuskokwim would gather wood to make houses"
    },
    "122": {
        "startTime": 952.42,
        "endTime": 957.392,
        "transcript": "Tamakunek atussiyaanringameng",
        "translation": "Because people aren't using those too much anymore"
    },
    "123": {
        "startTime": 957.403,
        "endTime": 972.374,
        "transcript": "Cali nallmeni atuqaqulang'e'rmegteki mud house-at au͡gkut apqait, tamatum nalliini atutullruamegteki up'nerkillerni-llu, kiillerni, uksuillerni-llu",
        "translation": "And though they used what they called mud houses in my time, because they had those at that time in spring camps, fish camps, and winter camps"
    },
    "124": {
        "startTime": 972.398,
        "endTime": 975.283,
        "transcript": "Tua-i tamakut atuumamallrukait.",
        "translation": "They used those for a long time."
    },
    "125": {
        "startTime": 975.293,
        "endTime": 985.922,
        "transcript": "Tau͡gaam nunani waten ukut nunarraat camek caliaqata ikayugncarilartut caperqelaamegteki",
        "translation": "But in these villages, when these small vilalges work on things, they ask for help because they find them difficult"
    },
    "126": {
        "startTime": 985.931,
        "endTime": 994.131,
        "transcript": "Muriit-llu makut uqiggetenrilameng, canek-llu cayugcuutnek piitellruamta tamatum nalliini",
        "translation": "And because these logs are not light, and we didn't have machinery to pull them at that time"
    },
    "127": {
        "startTime": 994.157,
        "endTime": 999.185,
        "transcript": "Tau͡gaam tua-i unatetgun tegularluki pitullruameng.",
        "translation": "Because they only took [and hauled] things by hand."
    },
    "128": {
        "startTime": 1000.571,
        "endTime": 1017.2,
        "transcript": "Cali tua-i qanruyutelaameng elpengevkalaitkut, ilateng elpengevkarluki uumek ikayurnarqellriamek piaqameng.",
        "translation": "Also, it's because they speak to each other to notify those around them when they do something that requires help."
    },
    "129": {
        "startTime": 1017.835,
        "endTime": 1025.164,
        "transcript": "Tua-i-llu nutaan imkut yuut taukuni nunarrarni uitalriit",
        "translation": "Then those people who live in that small village"
    },
    "130": {
        "startTime": 1026.044,
        "endTime": 1037.344,
        "transcript": "Kitakiilaraitkut camek pirpanrilngurmek ikayuutarkaunrilengramta ullautesqelluta.",
        "translation": "THey tell us to come even though they're not working on something great that requires us to help."
    },
    "131": {
        "startTime": 1038.562,
        "endTime": 1048.59,
        "transcript": "Tua-i ellait taqneret ellaita calillgutekluteng piaqata camek ellimeraqatkut wangkuta tua-i",
        "translation": "When those adults work together on something and they order us to do things"
    },
    "132": {
        "startTime": 1048.602,
        "endTime": 1058.345,
        "transcript": "Ca im' pirpanrilnguq aqvaaqluku, calissuun-llu ca-llu imna ellimerutekaqatgu aqvaaqluku tua-i wangkuta.",
        "translation": "We get that insignificant thing, and when they order us to get some tool or something, we would get it."
    },
    "133": {
        "startTime": 1058.368,
        "endTime": 1066.897,
        "transcript": "Tua-i tallikelriacetun tamakut taqneret makut camek caliaqameng",
        "translation": "We're like the arms of those adults when they work on something"
    },
    "134": {
        "startTime": 1066.909,
        "endTime": 1078.68,
        "transcript": "Enemek-llu eneliqatarqameng tagutelaamegteki piavet tua-i caliaqvigkaan nuniinun, maaken mermek tagulluku.",
        "translation": "Because when they're going to make houses, they bring those inland to where they're going to work on it, bringing them inland from the water here."
    },
    "135": {
        "startTime": 1079.092,
        "endTime": 1083.277,
        "transcript": "Wall'u cali",
        "translation": "Or also"
    },
    "136": {
        "startTime": 1084.281,
        "endTime": 1099.037,
        "transcript": "Imumi-am nunalget ukut mat'umek-am ikayungcaritullrulriit qasgimek-llu uumek caliqata'arqameng",
        "translation": "A long time ago, these villages would ask for help when they were going to work on this community house"
    },
    "137": {
        "startTime": 1099.848,
        "endTime": 1107.305,
        "transcript": "Qasgim caliaqsaraa angengami, muragpall'e'rnek-llu piyaraullruami canirtarnek.",
        "translation": "Because making a community house was a huge job, and it needed huge pieces of wood for the structure."
    },
    "138": {
        "startTime": 1107.826,
        "endTime": 1114.012,
        "transcript": "Nunalget kelegluki invite-arluki pitullruit.",
        "translation": "They would invite villages, kelegluki."
    },
    "139": {
        "startTime": 1114.022,
        "endTime": 1123.394,
        "transcript": "Ellaita ukut yuut yuk'arteng ikgellekluki piaqamegteki nunalget kelelarait invite-arluki nunameggnun",
        "translation": "When they thought that they didn't have enough people, they would invite other villages to their own."
    },
    "140": {
        "startTime": 1123.4,
        "endTime": 1131.514,
        "transcript": "Aperluku qasgimek caliqatarniluteng, ikayuusqelluteng.",
        "translation": "Saying that they were going to work on a community house, asking for help."
    },
    "141": {
        "startTime": 1131.976,
        "endTime": 1141.862,
        "transcript": "Tua-i-ll' taukut nunalget invite-allrit nunanek tua-i tekilluteng, tua-i nutaan tua-i tekilluteng taumun kelgumiimeng.",
        "translation": "Then that village that was invited arrived, they arrived because they were invited there."
    },
    "142": {
        "startTime": 1142.327,
        "endTime": 1147.399,
        "transcript": "Ak'a tua-i muriit tau͡gaam upingaluteng tua-i kanani pikait.",
        "translation": "The wood they were going to use was already ready down there."
    },
    "143": {
        "startTime": 1148.831,
        "endTime": 1159.16,
        "transcript": "Nutaan tua-i qavcin nunat, malruin-llu kelellrit tua-i calillgutekluteng caliluteng ikayuqluteng.",
        "translation": "Then the several villages, even two, that they invited worked together, helping each other."
    },
    "144": {
        "startTime": 1159.327,
        "endTime": 1166.684,
        "transcript": "Tauna enerpall'er qasgiq caliaqluku ikayuqluteng.",
        "translation": "They worked together on that huge sod house, that community house."
    },
    "145": {
        "startTime": 1167.109,
        "endTime": 1172.166,
        "transcript": "Marayamek-llu patulaamegteki tamaani qasgit",
        "translation": "And because they would cover those community houses with sod"
    },
    "146": {
        "startTime": 1172.261,
        "endTime": 1187.875,
        "transcript": "Makunek tua-i canegnek-llu kanevyailkucirraarluki tua-i nutaan maryamek patulaamegteki muriit tamakut canirtaalteng taqumariaqata.",
        "translation": "And because they would cover them with sod after they put in grass so it wouldn't crumble when the wood they put on their sides were finished."
    },
    "147": {
        "startTime": 1188.454,
        "endTime": 1198.295,
        "transcript": "Tua-i-am tuaten nutaan tauna caliaqluku taqvianun.",
        "translation": "They worked on that like that until it was finished."
    },
    "148": {
        "startTime": 1198.495,
        "endTime": 1206.095,
        "transcript": "Tua-i tau͡gaam taqngan nutaan imkut invite-alteng nunanek, ukut nunalget nutaan",
        "translation": "But when it was finished, the villages they invited, the gathered villages"
    },
    "149": {
        "startTime": 1206.42,
        "endTime": 1212.334,
        "transcript": "Maa-i nallemteńi ap'laqput potluck-aarluteng.",
        "translation": "They would have what we call today a potluck."
    },
    "150": {
        "startTime": 1212.354,
        "endTime": 1221.026,
        "transcript": "Tua-i tamatum nallii nutaan tua-i nerevkarluki kassiyucuarluteng tauna imna taqngan qasgiq.",
        "translation": "At that time, they would have a feast, a mini Messenger Feast potluck when that community house was done."
    },
    "151": {
        "startTime": 1221.039,
        "endTime": 1232.425,
        "transcript": "Nutaan tua-i yurarluteng tuaten tamatumek tua-i nutaan akililriacetun piluki, angniutekaatnek pivkarluki.",
        "translation": "Then they would dance as a form of payment to them, giving them a joyous time."
    },
    "152": {
        "startTime": 1232.434,
        "endTime": 1242.492,
        "transcript": "Nerevkarirraarluteng-llu tamana taqngan tuaten nutaan tamatumek nangnirluku nerevkaritmek.",
        "translation": "After they had given them a feast, when it was done, they ended it with that feast."
    },
    "153": {
        "startTime": 1242.513,
        "endTime": 1248.899,
        "transcript": "Tua-i potluck-aarluteng nutaan angnirluteng tua-i, yurarluteng tuaten.",
        "translation": "They had a potluck, enjoyed themselves, and even danced."
    },
    "154": {
        "startTime": 1248.905,
        "endTime": 1254.333,
        "transcript": "Tua-i corporation tua-i piluki ikayuulluuteng atunem.",
        "translation": "It was like a [community] corporation, helping each other."
    },
    "155": {
        "startTime": 1254.705,
        "endTime": 1264.019,
        "transcript": "Tua-i tuacetun-llu yuum ataucim caliarkaa cali tua-i ikayurtaagulluteng atunem pitullruameng",
        "translation": "Because they would help each other like that with one person's job"
    },
    "156": {
        "startTime": 1264.038,
        "endTime": 1273.052,
        "transcript": "Tuaten tauna ca imna piqataqiit yuum ataucim pia tauna ikayurluku.",
        "translation": "With what they were going to do like that, they would help that person."
    },
    "157": {
        "startTime": 1273.308,
        "endTime": 1282.751,
        "transcript": "Ellimaaluta tuaten wangkuta ikayuulluta tuaten ellaitni nayurluki pisqelluki.",
        "translation": "They even told us to helo like that, staying with them [in case they needed anything]."
    },
    "158": {
        "startTime": 1283.104,
        "endTime": 1293.318,
        "transcript": "Tua-i cali camek ukut nunat cali-am yuk tauna atauciq pinrilnge'rmegteggu",
        "translation": "Also, these villages, even though they weren't [going to help] that one person"
    },
    "159": {
        "startTime": 1293.751,
        "endTime": 1305.265,
        "transcript": "Ikayuutellerkarteng-am cali ca igvartaqamegteggu qaillun piyugluteng nunat ukut",
        "translation": "When they bring up something that needs help when this village wants to do something"
    },
    "160": {
        "startTime": 1305.282,
        "endTime": 1317.796,
        "transcript": "Qanlartut imumi kanani nunani, nunat-ll' amllenrilameng",
        "translation": "They would say in the vilage down there, also because there weren't a lot of villages"
    },
    "161": {
        "startTime": 1317.806,
        "endTime": 1324.735,
        "transcript": "Ukut Moravian mission-aat ayagniqarraalrata kinguani",
        "translation": "After the Moravian mission first started"
    },
    "162": {
        "startTime": 1324.744,
        "endTime": 1332.144,
        "transcript": "Nutaan-am yuut ikayuqluteng ukut wani mission-aat tuskalingarrluteng.",
        "translation": "The people helped each other, and these missions' plywood [houses] got built."
    },
    "163": {
        "startTime": 1332.336,
        "endTime": 1341.922,
        "transcript": "Nutaan-am tua-i mission-aanek waken ayagluta tumyariluta qamavet kipusvigpagmun-gguq taumun.",
        "translation": "Starting from the missions, we made boardwalks upriver to what they called the big store."
    }
};